export default interface PagedResult<T> {
  items: T[]
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export const DEFAULT_PAGE_SIZE = 20
export const FULL_LIST_PAGE_SIZE = 1000

export const emptyPagedResult = <T,>(page = 1, pageSize = DEFAULT_PAGE_SIZE): PagedResult<T> => ({
  items: [],
  page,
  pageSize,
  totalCount: 0,
  totalPages: 0,
})
